(() => {
  const arrange = () => {
    document.querySelectorAll('.product-details .group-block-content').forEach((container) => {
      const rank = (block) => {
        if (block.querySelector('h1')) return 1;
        if (block.matches('product-price') || block.querySelector('product-price')) return 2;
        if (block.matches('.buy-buttons-block') || block.querySelector('.buy-buttons-block')) return 3;
        if (block.matches('.shipping-badge-wrap') || block.querySelector('.shipping-badge-wrap')) return 4;
        if ((block.matches('rte-formatter, .text-block') || block.querySelector('rte-formatter, .text-block')) && !block.querySelector('h1')) return 5;
        if (block.matches('variant-picker, variant-selector') || block.querySelector('variant-picker, variant-selector')) return 6;

        return 7;
      };

      const original = Array.from(container.children);
      const sorted = original
        .map((block, index) => ({ block, index, rank: rank(block) }))
        .sort((a, b) => a.rank - b.rank || a.index - b.index)
        .map(({ block }) => block);

      if (original.some((block, index) => block !== sorted[index])) {
        container.append(...sorted);
      }
    });
  };

  const hideBrickShippingSpecifications = () => {
    const hiddenLabels = new Set([
      'Szállítási hosszúság (cm)',
      'Szállítási szélesség (cm)',
      'Szállítási magasság (cm)',
      'Szállítási súly (kg)',
      'Csomagolási térfogat',
    ]);

    document.querySelectorAll('.product-details--brick tr').forEach((row) => {
      const label = row.querySelector('th')?.textContent.trim();

      if (hiddenLabels.has(label)) row.hidden = true;
    });
  };

  const start = () => {
    arrange();
    hideBrickShippingSpecifications();

    const observer = new MutationObserver(arrange);
    document.querySelectorAll('.product-details .group-block-content').forEach((container) => {
      observer.observe(container, { childList: true, subtree: true });
    });

    window.setTimeout(arrange, 100);
    window.setTimeout(arrange, 500);
    window.setTimeout(arrange, 1500);
    window.setTimeout(hideBrickShippingSpecifications, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
